import React, { useEffect, useState } from "react";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";
//theme
import Theme, { useStyles } from "../../../Theme.js";

//Images
import sentierBackground from "../../../../images/sentierBackground.jpg";
import HOTEL from "../../../../images/pictos-ok/HOTEL.svg";
import CAMPING from "../../../../images/pictos-ok/CAMPING.svg";
import GITE from "../../../../images/pictos-ok/GITES.svg";
import chambre_hotes from "../../../../images/pictos-ok/CHAMBREDHOTES.svg";
import location_privee from "../../../../images/pictos-ok/LOCATION.svg";
import village_vacances from "../../../../images/pictos-ok/VILLAGE.svg";
const Step1 = (props) => {
  const classes = useStyles();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (props.result.type_hebergement) {
      setValue(props.result.type_hebergement);
      props.setAuthorization(true);
      //document.getElementById(props.location.state).focus();
    } else {
      props.setAuthorization(false);
    }
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setValue(event.target.value);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["type_hebergement"] = event.target.value;
    props.setResult(newResult);
    // Une fois que la réponse est donnée, autorise à avancer dans le form
    props.setAuthorization(true);
    props.goForth(true);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        A quel type d'hébergement avez vous eu à faire ?
      </FormLabel>
      <RadioGroup
        aria-label="hebergement"
        name="hebergement"
        value={value}
        onChange={handleChange}
      >
        <FormControlLabel
          value="hotel"
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={HOTEL}
                  alt="hotel"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={HOTEL}
                  alt="hotel"
                />
              }
            />
          }
          label="hotel"
          className={
            classes.themeButton + " " + (value === "hotel" ? "checked" : "")
          }
        />
        <FormControlLabel
          value="camping"
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={CAMPING}
                  alt="hotel"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={CAMPING}
                  alt="hotel"
                />
              }
            />
          }
          label="camping"
          className={
            classes.themeButton + " " + (value === "camping" ? "checked" : "")
          }
        />
        <FormControlLabel
          value="gite"
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={GITE}
                  alt="gite"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={GITE}
                  alt="gite"
                />
              }
            />
          }
          label="gîte"
          className={
            classes.themeButton + " " + (value === "gite" ? "checked" : "")
          }
        />
        <FormControlLabel
          value="chambre_hotes"
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={chambre_hotes}
                  alt="chambre_hotes"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={chambre_hotes}
                  alt="chambre_hotes"
                />
              }
            />
          }
          label="chambre d'hôtes"
          className={
            classes.themeButton +
            " " +
            (value === "chambre_hotes" ? "checked" : "")
          }
        />
        <FormControlLabel
          value="location_privee"
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={location_privee}
                  alt="location_privee"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={location_privee}
                  alt="location_privee"
                />
              }
            />
          }
          label="location type Airbnb"
          className={
            classes.themeButton +
            " " +
            (value === "location_privee" ? "checked" : "")
          }
        />
        <FormControlLabel
          value="village_vacances"
          control={
            <Radio
              className={classes.fullradio}
              icon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={village_vacances}
                  alt="village_vacances"
                />
              }
              checkedIcon={
                <img
                  style={{
                    maxHeight: 65,
                    maxWidth: "100%",
                    marginBottom: "10px",
                  }}
                  src={village_vacances}
                  alt="village_vacances"
                />
              }
            />
          }
          label="village vacances"
          className={
            classes.themeButton +
            " " +
            (value === "village_vacances" ? "checked" : "")
          }
        />
      </RadioGroup>
    </FormControl>
  );
};

export default Step1;
